webpackJsonp([35783957827783],{

/***/ 78:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * This is the web browser implementation of `debug()`.
	 *
	 * Expose `debug()` as the module.
	 */
	
	exports = module.exports = __webpack_require__(79);
	exports.log = log;
	exports.formatArgs = formatArgs;
	exports.save = save;
	exports.load = load;
	exports.useColors = useColors;
	exports.storage = 'undefined' != typeof chrome
	               && 'undefined' != typeof chrome.storage
	                  ? chrome.storage.local
	                  : localstorage();
	
	/**
	 * Colors.
	 */
	
	exports.colors = [
	  'lightseagreen',
	  'forestgreen',
	  'goldenrod',
	  'dodgerblue',
	  'darkorchid',
	  'crimson'
	];
	
	/**
	 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
	 * and the Firebug extension (any Firefox version) are known
	 * to support "%c" CSS customizations.
	 *
	 * TODO: add a `localStorage` variable to explicitly enable/disable colors
	 */
	
	function useColors() {
	  // NB: In an Electron preload script, document will be defined but not fully
	  // initialized. Since we know we're in Chrome, we'll just detect this case
	  // explicitly
	  if (typeof window !== 'undefined' && window.process && window.process.type === 'renderer') {
	    return true;
	  }
	
	  // is webkit? http://stackoverflow.com/a/16459606/376773
	  // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
	  return (typeof document !== 'undefined' && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance) ||
	    // is firebug? http://stackoverflow.com/a/398120/376773
	    (typeof window !== 'undefined' && window.console && (window.console.firebug || (window.console.exception && window.console.table))) ||
	    // is firefox >= v31?
	    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
	    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31) ||
	    // double check webkit in userAgent just in case we are in a worker
	    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/));
	}
	
	/**
	 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
	 */
	
	exports.formatters.j = function(v) {
	  try {
	    return JSON.stringify(v);
	  } catch (err) {
	    return '[UnexpectedJSONParseError]: ' + err.message;
	  }
	};
	
	
	/**
	 * Colorize log arguments if enabled.
	 *
	 * @api public
	 */
	
	function formatArgs(args) {
	  var useColors = this.useColors;
	
	  args[0] = (useColors ? '%c' : '')
	    + this.namespace
	    + (useColors ? ' %c' : ' ')
	    + args[0]
	    + (useColors ? '%c ' : ' ')
	    + '+' + exports.humanize(this.diff);
	
	  if (!useColors) return;
	
	  var c = 'color: ' + this.color;
	  args.splice(1, 0, c, 'color: inherit')
	
	  // the final "%c" is somewhat tricky, because there could be other
	  // arguments passed either before or after the %c, so we need to
	  // figure out the correct index to insert the CSS into
	  var index = 0;
	  var lastC = 0;
	  args[0].replace(/%[a-zA-Z%]/g, function(match) {
	    if ('%%' === match) return;
	    index++;
	    if ('%c' === match) {
	      // we only are interested in the *last* %c
	      // (the user may have provided their own)
	      lastC = index;
	    }
	  });
	
	  args.splice(lastC, 0, c);
	}
	
	/**
	 * Invokes `console.log()` when available.
	 * No-op when `console.log` is not a "function".
	 *
	 * @api public
	 */
	
	function log() {
	  // this hackery is required for IE8/9, where
	  // the `console.log` function doesn't have 'apply'
	  return 'object' === typeof console
	    && console.log
	    && Function.prototype.apply.call(console.log, console, arguments);
	}
	
	/**
	 * Save `namespaces`.
	 *
	 * @param {String} namespaces
	 * @api private
	 */
	
	function save(namespaces) {
	  try {
	    if (null == namespaces) {
	      exports.storage.removeItem('debug');
	    } else {
	      exports.storage.debug = namespaces;
	    }
	  } catch(e) {}
	}
	
	/**
	 * Load `namespaces`.
	 *
	 * @return {String} returns the previously persisted debug modes
	 * @api private
	 */
	
	function load() {
	  var r;
	  try {
	    r = exports.storage.debug;
	  } catch(e) {}
	
	  // If debug isn't set in LS, and we're in Electron, try to load $DEBUG
	  if (!r && typeof process !== 'undefined' && 'env' in process) {
	    r = ({"NODE_ENV":"production","PUBLIC_DIR":"/opt/build/repo/public"}).DEBUG;
	  }
	
	  return r;
	}
	
	/**
	 * Enable namespaces listed in `localStorage.debug` initially.
	 */
	
	exports.enable(load());
	
	/**
	 * Localstorage attempts to return the localstorage.
	 *
	 * This is necessary because safari throws
	 * when a user disables cookies/localstorage
	 * and you attempt to access it.
	 *
	 * @return {LocalStorage}
	 * @api private
	 */
	
	function localstorage() {
	  try {
	    return window.localStorage;
	  } catch (e) {}
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(35)))

/***/ }),

/***/ 79:
/***/ (function(module, exports, __webpack_require__) {

	
	/**
	 * This is the common logic for both the Node.js and web browser
	 * implementations of `debug()`.
	 *
	 * Expose `debug()` as the module.
	 */
	
	exports = module.exports = createDebug.debug = createDebug['default'] = createDebug;
	exports.coerce = coerce;
	exports.disable = disable;
	exports.enable = enable;
	exports.enabled = enabled;
	exports.humanize = __webpack_require__(88);
	
	/**
	 * The currently active debug mode names, and names to skip.
	 */
	
	exports.names = [];
	exports.skips = [];
	
	/**
	 * Map of special "%n" handling functions, for the debug "format" argument.
	 *
	 * Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
	 */
	
	exports.formatters = {};
	
	/**
	 * Previous log timestamp.
	 */
	
	var prevTime;
	
	/**
	 * Select a color.
	 * @param {String} namespace
	 * @return {Number}
	 * @api private
	 */
	
	function selectColor(namespace) {
	  var hash = 0, i;
	
	  for (i in namespace) {
	    hash  = ((hash << 5) - hash) + namespace.charCodeAt(i);
	    hash |= 0; // Convert to 32bit integer
	  }
	
	  return exports.colors[Math.abs(hash) % exports.colors.length];
	}
	
	/**
	 * Create a debugger with the given `namespace`.
	 *
	 * @param {String} namespace
	 * @return {Function}
	 * @api public
	 */
	
	function createDebug(namespace) {
	
	  function debug() {
	    // disabled?
	    if (!debug.enabled) return;
	
	    var self = debug;
	
	    // set `diff` timestamp
	    var curr = +new Date();
	    var ms = curr - (prevTime || curr);
	    self.diff = ms;
	    self.prev = prevTime;
	    self.curr = curr;
	    prevTime = curr;
	
	    // turn the `arguments` into a proper Array
	    var args = new Array(arguments.length);
	    for (var i = 0; i < args.length; i++) {
	      args[i] = arguments[i];
	    }
	
	    args[0] = exports.coerce(args[0]);
	
	    if ('string' !== typeof args[0]) {
	      // anything else let's inspect with %O
	      args.unshift('%O');
	    }
	
	    // apply any `formatters` transformations
	    var index = 0;
	    args[0] = args[0].replace(/%([a-zA-Z%])/g, function(match, format) {
	      // if we encounter an escaped % then don't increase the array index
	      if (match === '%%') return match;
	      index++;
	      var formatter = exports.formatters[format];
	      if ('function' === typeof formatter) {
	        var val = args[index];
	        match = formatter.call(self, val);
	
	        // now we need to remove `args[index]` since it's inlined in the `format`
	        args.splice(index, 1);
	        index--;
	      }
	      return match;
	    });
	
	    // apply env-specific formatting (colors, etc.)
	    exports.formatArgs.call(self, args);
	
	    var logFn = debug.log || exports.log || console.log.bind(console);
	    logFn.apply(self, args);
	  }
	
	  debug.namespace = namespace;
	  debug.enabled = exports.enabled(namespace);
	  debug.useColors = exports.useColors();
	  debug.color = selectColor(namespace);
	
	  // env-specific initialization logic for debug instances
	  if ('function' === typeof exports.init) {
	    exports.init(debug);
	  }
	
	  return debug;
	}
	
	/**
	 * Enables a debug mode by namespaces. This can include modes
	 * separated by a colon and wildcards.
	 *
	 * @param {String} namespaces
	 * @api public
	 */
	
	function enable(namespaces) {
	  exports.save(namespaces);
	
	  exports.names = [];
	  exports.skips = [];
	
	  var split = (typeof namespaces === 'string' ? namespaces : '').split(/[\s,]+/);
	  var len = split.length;
	
	  for (var i = 0; i < len; i++) {
	    if (!split[i]) continue; // ignore empty strings
	    namespaces = split[i].replace(/\*/g, '.*?');
	    if (namespaces[0] === '-') {
	      exports.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
	    } else {
	      exports.names.push(new RegExp('^' + namespaces + '$'));
	    }
	  }
	}
	
	/**
	 * Disable debug output.
	 *
	 * @api public
	 */
	
	function disable() {
	  exports.enable('');
	}
	
	/**
	 * Returns true if the given mode name is enabled, false otherwise.
	 *
	 * @param {String} name
	 * @return {Boolean}
	 * @api public
	 */
	
	function enabled(name) {
	  var i, len;
	  for (i = 0, len = exports.skips.length; i < len; i++) {
	    if (exports.skips[i].test(name)) {
	      return false;
	    }
	  }
	  for (i = 0, len = exports.names.length; i < len; i++) {
	    if (exports.names[i].test(name)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	/**
	 * Coerce `val`.
	 *
	 * @param {Mixed} val
	 * @return {Mixed}
	 * @api private
	 */
	
	function coerce(val) {
	  if (val instanceof Error) return val.stack || val.message;
	  return val;
	}


/***/ }),

/***/ 87:
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Module dependencies
	 */
	
	var debug = __webpack_require__(78)('jsonp');
	
	/**
	 * Module exports.
	 */
	
	module.exports = jsonp;
	
	/**
	 * Callback index.
	 */
	
	var count = 0;
	
	/**
	 * Noop function.
	 */
	
	function noop(){}
	
	/**
	 * JSONP handler
	 *
	 * Options:
	 *  - param {String} qs parameter (`callback`)
	 *  - prefix {String} qs parameter (`__jp`)
	 *  - name {String} qs parameter (`prefix` + incr)
	 *  - timeout {Number} how long after a timeout error is emitted (`60000`)
	 *
	 * @param {String} url
	 * @param {Object|Function} optional options / callback
	 * @param {Function} optional callback
	 */
	
	function jsonp(url, opts, fn){
	  if ('function' == typeof opts) {
	    fn = opts;
	    opts = {};
	  }
	  if (!opts) opts = {};
	
	  var prefix = opts.prefix || '__jp';
	
	  // use the callback name that was passed if one was provided.
	  // otherwise generate a unique name by incrementing our counter.
	  var id = opts.name || (prefix + (count++));
	
	  var param = opts.param || 'callback';
	  var timeout = null != opts.timeout ? opts.timeout : 60000;
	  var enc = encodeURIComponent;
	  var target = document.getElementsByTagName('script')[0] || document.head;
	  var script;
	  var timer;
	
	
	  if (timeout) {
	    timer = setTimeout(function(){
	      cleanup();
	      if (fn) fn(new Error('Timeout'));
	    }, timeout);
	  }
	
	  function cleanup(){
	    if (script.parentNode) script.parentNode.removeChild(script);
	    window[id] = noop;
	    if (timer) clearTimeout(timer);
	  }
	
	  function cancel(){
	    if (window[id]) {
	      cleanup();
	    }
	  }
	
	  window[id] = function(data){
	    debug('jsonp got', data);
	    cleanup();
	    if (fn) fn(null, data);
	  };
	
	  // add qs component
	  url += (~url.indexOf('?') ? '&' : '?') + param + '=' + enc(id);
	  url = url.replace('?&', '?');
	
	  debug('jsonp req "%s"', url);
	
	  // create script
	  script = document.createElement('script');
	  script.src = url;
	  target.parentNode.insertBefore(script, target);
	
	  return cancel;
	}


/***/ }),

/***/ 88:
/***/ (function(module, exports) {

	/**
	 * Helpers.
	 */
	
	var s = 1000;
	var m = s * 60;
	var h = m * 60;
	var d = h * 24;
	var y = d * 365.25;
	
	/**
	 * Parse or format the given `val`.
	 *
	 * Options:
	 *
	 *  - `long` verbose formatting [false]
	 *
	 * @param {String|Number} val
	 * @param {Object} [options]
	 * @throws {Error} throw an error if val is not a non-empty string or a number
	 * @return {String|Number}
	 * @api public
	 */
	
	module.exports = function(val, options) {
	  options = options || {};
	  var type = typeof val;
	  if (type === 'string' && val.length > 0) {
	    return parse(val);
	  } else if (type === 'number' && isNaN(val) === false) {
	    return options.long ? fmtLong(val) : fmtShort(val);
	  }
	  throw new Error(
	    'val is not a non-empty string or a valid number. val=' +
	      JSON.stringify(val)
	  );
	};
	
	/**
	 * Parse the given `str` and return milliseconds.
	 *
	 * @param {String} str
	 * @return {Number}
	 * @api private
	 */
	
	function parse(str) {
	  str = String(str);
	  if (str.length > 100) {
	    return;
	  }
	  var match = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(
	    str
	  );
	  if (!match) {
	    return;
	  }
	  var n = parseFloat(match[1]);
	  var type = (match[2] || 'ms').toLowerCase();
	  switch (type) {
	    case 'years':
	    case 'year':
	    case 'yrs':
	    case 'yr':
	    case 'y':
	      return n * y;
	    case 'days':
	    case 'day':
	    case 'd':
	      return n * d;
	    case 'hours':
	    case 'hour':
	    case 'hrs':
	    case 'hr':
	    case 'h':
	      return n * h;
	    case 'minutes':
	    case 'minute':
	    case 'mins':
	    case 'min':
	    case 'm':
	      return n * m;
	    case 'seconds':
	    case 'second':
	    case 'secs':
	    case 'sec':
	    case 's':
	      return n * s;
	    case 'milliseconds':
	    case 'millisecond':
	    case 'msecs':
	    case 'msec':
	    case 'ms':
	      return n;
	    default:
	      return undefined;
	  }
	}
	
	/**
	 * Short format for `ms`.
	 *
	 * @param {Number} ms
	 * @return {String}
	 * @api private
	 */
	
	function fmtShort(ms) {
	  if (ms >= d) {
	    return Math.round(ms / d) + 'd';
	  }
	  if (ms >= h) {
	    return Math.round(ms / h) + 'h';
	  }
	  if (ms >= m) {
	    return Math.round(ms / m) + 'm';
	  }
	  if (ms >= s) {
	    return Math.round(ms / s) + 's';
	  }
	  return ms + 'ms';
	}
	
	/**
	 * Long format for `ms`.
	 *
	 * @param {Number} ms
	 * @return {String}
	 * @api private
	 */
	
	function fmtLong(ms) {
	  return plural(ms, d, 'day') ||
	    plural(ms, h, 'hour') ||
	    plural(ms, m, 'minute') ||
	    plural(ms, s, 'second') ||
	    ms + ' ms';
	}
	
	/**
	 * Pluralization helper.
	 */
	
	function plural(ms, n, name) {
	  if (ms < n) {
	    return;
	  }
	  if (ms < n * 1.5) {
	    return Math.floor(ms / n) + ' ' + name;
	  }
	  return Math.ceil(ms / n) + ' ' + name + 's';
	}


/***/ }),

/***/ 35:
/***/ (function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ }),

/***/ 94:
/***/ (function(module, exports, __webpack_require__) {

	!function(t,e){ true?module.exports=e():"function"==typeof define&&define.amd?define("to-querystring",[],e):"object"==typeof exports?exports["to-querystring"]=e():t["to-querystring"]=e()}(this,function(){return function(t){function e(o){if(n[o])return n[o].exports;var r=n[o]={i:o,l:!1,exports:{}};return t[o].call(r.exports,r,r.exports,e),r.l=!0,r.exports}var n={};return e.m=t,e.c=n,e.d=function(t,n,o){e.o(t,n)||Object.defineProperty(t,n,{configurable:!1,enumerable:!0,get:o})},e.n=function(t){var n=t&&t.__esModule?function(){return t.default}:function(){return t};return e.d(n,"a",n),n},e.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},e.p="",e(e.s=0)}([function(t,e,n){"use strict";function o(t,e,n){if("object"===(void 0===e?"undefined":i(e))){return""+u(e,""+n+(""+t+(n&&"]")+"["))}return n&&n.length?""+n+t+"]="+encodeURIComponent(e):t+"="+encodeURIComponent(e)}function r(t,e,n){return e.map(function(e){return o(t,e,n)}).join("&")}function u(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"";return Object.keys(t).filter(function(e){return void 0!==t[e]}).map(function(n){return t[n]&&Array.isArray(t[n])?r(n,t[n],e):o(n,t[n],e)}).join("&").replace(/%20/g,"+")}Object.defineProperty(e,"__esModule",{value:!0});var i="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t};e.default=u}])});

/***/ }),

/***/ 140:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyImage = __webpack_require__(8);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EndorsementSection = function EndorsementSection(props) {
	  var endorsements = [{
	    name: 'Austin-American Statesman',
	    resolutions: props.statesmanImage.resolutions,
	    href: 'https://www.statesman.com/opinion/20181019/editorial-prop-is-key-piece-to-austins-affordability-puzzle?fbclid=IwAR2zNPi1h6-6SJQZf409xTZEEbEDKNVjygDqcRAIDLcQa06Hh6Cvkt_aQvw'
	  }, {
	    name: 'Austin Chronicle',
	    resolutions: props.chronicleImage.resolutions,
	    href: 'https://www.austinchronicle.com/news/2018-10-19/chronicle-endorsements-city-propositions/'
	  }];
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'container py-4' },
	    _react2.default.createElement(
	      'div',
	      { className: 'row' },
	      _react2.default.createElement(
	        'div',
	        { className: 'col' },
	        _react2.default.createElement(
	          'h2',
	          { className: 'mb-4', style: { fontWeight: 'bold' } },
	          'Endorsed By'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      {
	        className: 'row align-items-center justify-content-center',
	        style: { textAlign: 'center' }
	      },
	      endorsements.map(function (endorsements, i) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'col-sm hover01', key: i },
	          _react2.default.createElement(
	            'a',
	            { href: endorsements.href, target: '_blank' },
	            _react2.default.createElement(
	              'figure',
	              null,
	              _react2.default.createElement(_gatsbyImage2.default, {
	                title: endorsements.name,
	                alt: endorsements.name,
	                resolutions: endorsements.resolutions
	              })
	            )
	          )
	        );
	      })
	    )
	  );
	};
	
	exports.default = EndorsementSection;
	module.exports = exports['default'];

/***/ }),

/***/ 142:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Country_Neighbors = __webpack_require__(359);
	
	var _Country_Neighbors2 = _interopRequireDefault(_Country_Neighbors);
	
	var _Country_Neighbors3 = __webpack_require__(360);
	
	var _Country_Neighbors4 = _interopRequireDefault(_Country_Neighbors3);
	
	var _placeholder = __webpack_require__(132);
	
	var _placeholder2 = _interopRequireDefault(_placeholder);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var HomepageVideo = function (_Component) {
	  _inherits(HomepageVideo, _Component);
	
	  function HomepageVideo() {
	    _classCallCheck(this, HomepageVideo);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  HomepageVideo.prototype.componentDidMount = function componentDidMount() {
	    setTimeout(function () {
	      // document.getElementById('video').muted = false
	      document.getElementById('video').play();
	    }, 1000);
	  };
	
	  HomepageVideo.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      { style: { textAlign: 'center' } },
	      _react2.default.createElement(
	        'video',
	        {
	          id: 'video',
	          controls: true,
	          autoplay: true,
	          muted: true,
	          style: {
	            width: '100%'
	            // border: '3px solid black'
	          },
	          poster: _placeholder2.default
	        },
	        _react2.default.createElement('source', { src: _Country_Neighbors2.default, type: 'video/mp4' }),
	        _react2.default.createElement('source', { src: _Country_Neighbors4.default, type: 'video/webm' }),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Your browser doesn\'t support HTML5 video. Here is a',
	          ' ',
	          _react2.default.createElement(
	            'a',
	            { href: _Country_Neighbors2.default },
	            'link to the video'
	          ),
	          ' instead.'
	        )
	      )
	    );
	  };
	
	  return HomepageVideo;
	}(_react.Component);
	
	exports.default = HomepageVideo;
	module.exports = exports['default'];

/***/ }),

/***/ 250:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 143:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(4);
	
	var _MailchimpSubscribe = __webpack_require__(53);
	
	var _MailchimpSubscribe2 = _interopRequireDefault(_MailchimpSubscribe);
	
	__webpack_require__(14);
	
	__webpack_require__(250);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var url = 'https://keepaustinaffordable.us19.list-manage.com/subscribe/post?u=ca7f4fe2e5eae30cc8bc21a43&amp;id=4fc75ae140';
	
	function encode(data) {
	  return Object.keys(data).map(function (key) {
	    return encodeURIComponent(key) + '=' + encodeURIComponent(data[key]);
	  }).join('&');
	}
	
	var CustomForm = function CustomForm(_ref) {
	  var status = _ref.status,
	      message = _ref.message,
	      onValidated = _ref.onValidated;
	
	  var email = void 0,
	      lname = void 0,
	      fname = void 0,
	      supporter = void 0,
	      volunteer = void 0;
	  var submit = function submit() {
	    return email && fname && lname && supporter && volunteer && email.value.indexOf('@') > -1 && onValidated({
	      EMAIL: email.value,
	      FNAME: fname.value,
	      LNAME: lname.value,
	      SUPPORTER: supporter.value,
	      VOLUNTEER: volunteer.value
	    });
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'form-group row p-3 p-md-4 container MailchimpForm form-inline' },
	    _react2.default.createElement(
	      'h5',
	      { className: 'col-12 mb-3' },
	      'Get our latest updates'
	    ),
	    status === 'sending' && _react2.default.createElement(
	      'div',
	      { style: { color: 'blue' } },
	      'sending...'
	    ),
	    status === 'error' && _react2.default.createElement('div', {
	      style: { color: 'red' },
	      dangerouslySetInnerHTML: { __html: message }
	    }),
	    status === 'success' && _react2.default.createElement('div', {
	      style: { color: 'white' },
	      dangerouslySetInnerHTML: { __html: message }
	    }),
	    _react2.default.createElement('input', {
	      ref: function ref(node) {
	        return email = node;
	      },
	      type: 'email',
	      placeholder: 'Email',
	      className: 'form-control form-control-lg col-12 mb-2'
	    }),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('input', {
	      ref: function ref(node) {
	        return fname = node;
	      },
	      type: 'text',
	      placeholder: 'First Name',
	      className: 'form-control form-control-lg col-12 mb-2'
	    }),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('input', {
	      ref: function ref(node) {
	        return lname = node;
	      },
	      type: 'text',
	      placeholder: 'Last Name',
	      className: 'form-control form-control-lg col-12 mb-2'
	    }),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement(
	      'select',
	      {
	        className: 'custom-select mb-2 col-12 form-control form-control-md',
	        name: 'publicSupport',
	        ref: function ref(node) {
	          return supporter = node;
	        },
	        defaultValue: 0
	      },
	      _react2.default.createElement(
	        'option',
	        { value: 'No Answer' },
	        'Show me as a public supporter?'
	      ),
	      _react2.default.createElement(
	        'option',
	        { value: 'Yes' },
	        'Yes'
	      ),
	      _react2.default.createElement(
	        'option',
	        { value: 'No' },
	        'No'
	      )
	    ),
	    _react2.default.createElement(
	      'select',
	      {
	        className: 'custom-select mb-2 col-12 form-control form-control-md',
	        name: 'volunteer',
	        ref: function ref(node) {
	          return volunteer = node;
	        },
	        defaultValue: 0
	      },
	      _react2.default.createElement(
	        'option',
	        { value: 'No Answer' },
	        'Want to volunteer?'
	      ),
	      _react2.default.createElement(
	        'option',
	        { value: 'Yes' },
	        'Yes'
	      ),
	      _react2.default.createElement(
	        'option',
	        { value: 'No' },
	        'No'
	      )
	    ),
	    _react2.default.createElement(
	      'button',
	      { onClick: submit, className: 'col-12 mb-2 btn btn-info btn-lg' },
	      'Submit'
	    )
	  );
	};
	
	var MailchimpForm = function (_Component) {
	  _inherits(MailchimpForm, _Component);
	
	  function MailchimpForm() {
	    _classCallCheck(this, MailchimpForm);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  MailchimpForm.prototype.render = function render() {
	    return _react2.default.createElement(_MailchimpSubscribe2.default, {
	      url: url,
	      render: function render(_ref2) {
	        var subscribe = _ref2.subscribe,
	            status = _ref2.status,
	            message = _ref2.message;
	        return _react2.default.createElement(CustomForm, {
	          status: status,
	          message: message,
	          onValidated: function onValidated(formData) {
	            return subscribe(formData);
	          }
	        });
	      }
	    });
	  };
	
	  return MailchimpForm;
	}(_react.Component);
	
	exports.default = MailchimpForm;
	module.exports = exports['default'];

/***/ }),

/***/ 53:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _jsonp = __webpack_require__(87);
	
	var _jsonp2 = _interopRequireDefault(_jsonp);
	
	var _toQuerystring = __webpack_require__(94);
	
	var _toQuerystring2 = _interopRequireDefault(_toQuerystring);
	
	var _SimpleForm = __webpack_require__(54);
	
	var _SimpleForm2 = _interopRequireDefault(_SimpleForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var getAjaxUrl = function getAjaxUrl(url) {
	  return url.replace('/post?', '/post-json?');
	};
	
	var MailchimpSubscribe = function (_React$Component) {
	  _inherits(MailchimpSubscribe, _React$Component);
	
	  function MailchimpSubscribe() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, MailchimpSubscribe);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      status: null,
	      message: null
	    }, _this.subscribe = function (data) {
	      var params = (0, _toQuerystring2.default)(data);
	      var url = getAjaxUrl(_this.props.url) + '&' + params;
	      _this.setState({
	        status: 'sending',
	        message: null
	      }, function () {
	        return (0, _jsonp2.default)(url, {
	          param: 'c'
	        }, function (err, data) {
	          console.log('err, data', err, data);
	          if (err) {
	            _this.setState({
	              status: 'error',
	              message: err
	            });
	          } else if (data.result !== 'success') {
	            _this.setState({
	              status: 'error',
	              message: data.msg
	            });
	          } else {
	            _this.setState({
	              status: 'success',
	              message: data.msg
	            });
	          }
	        });
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  MailchimpSubscribe.prototype.render = function render() {
	    return this.props.render({
	      subscribe: this.subscribe,
	      status: this.state.status,
	      message: this.state.message
	    });
	  };
	
	  return MailchimpSubscribe;
	}(_react2.default.Component);
	
	MailchimpSubscribe.propTypes = {
	  render: _propTypes2.default.func,
	  url: _propTypes2.default.string.isRequired
	};
	
	MailchimpSubscribe.defaultProps = {
	  render: function render(_ref) {
	    var subscribe = _ref.subscribe,
	        status = _ref.status,
	        message = _ref.message;
	    return _react2.default.createElement(_SimpleForm2.default, {
	      status: status,
	      message: message,
	      onSubmitted: function onSubmitted(formData) {
	        return subscribe(formData);
	      }
	    });
	  }
	};
	
	exports.default = MailchimpSubscribe;
	module.exports = exports['default'];

/***/ }),

/***/ 146:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyImage = __webpack_require__(8);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _EndorsementForm = __webpack_require__(38);
	
	var _EndorsementForm2 = _interopRequireDefault(_EndorsementForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PartnerSection = function PartnerSection(props) {
	  var partners = [{
	    name: 'Meals on Wheels',
	    resolutions: props.mealsOnWheelsImage.resolutions,
	    href: 'https://www.mealsonwheelscentraltexas.org/'
	  }, {
	    name: 'Affordable Central Texas',
	    resolutions: props.affordableCTXImage.resolutions,
	    href: 'https://affordablectx.org/'
	  }, {
	    name: 'Austin Housing Coalition',
	    resolutions: props.austinHousingCoalitionImage.resolutions,
	    href: 'http://austinhousingcoalition.org/'
	  }, {
	    name: 'Habitat For Humanity',
	    resolutions: props.habitatForHumanityImage.resolutions,
	    href: 'https://www.austinhabitat.org/'
	  }, {
	    name: 'Foundation Communities',
	    resolutions: props.foundationCommunitiesImage.resolutions,
	    href: 'https://foundcom.org/'
	  }, {
	    name: 'SAFE Alliance',
	    resolutions: props.safeImage.resolutions,
	    href: ' http://www.safeaustin.org/'
	  }, {
	    name: 'Austin Board of Realtors',
	    resolutions: props.aborImage.resolutions,
	    href: 'https://www.abor.com/'
	  }, {
	    name: 'Housing Works',
	    resolutions: props.housingWorksAustinImage.resolutions,
	    href: 'http://housingworksaustin.org/'
	  }, {
	    name: 'Austin Urban League',
	    resolutions: props.austinUrbanLeagueImage.resolutions,
	    href: 'http://aaul.org/'
	  }, {
	    name: 'Easterseals',
	    resolutions: props.easterSealsImage.resolutions,
	    href: 'http://www.easterseals.com/centraltx/'
	  }, {
	    name: 'Caritas of Austin',
	    resolutions: props.caritasImage.resolutions,
	    href: 'https://www.caritasofaustin.org/'
	  }, {
	    name: 'DMA Company',
	    resolutions: props.dmaImage.resolutions,
	    href: 'https://dmacompanies.com/'
	  }, {
	    name: 'ECHO',
	    resolutions: props.echoImage.resolutions,
	    href: 'http://www.austinecho.org/'
	  }, {
	    name: 'LifeWorks',
	    resolutions: props.lifeworksImage.resolutions,
	    href: 'http://www.lifeworksaustin.org/'
	  }, {
	    name: 'Austin Community Design and Development Center',
	    resolutions: props.austinCommunityDesignCenterImage.resolutions,
	    href: 'https://acddc.org'
	  }, {
	    name: 'Guadalupe Neighborhood Development Corporation (GNDC)',
	    resolutions: props.gndcImage.resolutions,
	    href: 'http://www.guadalupendc.org/'
	  }];
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'container py-4' },
	    _react2.default.createElement(
	      'div',
	      { className: 'row' },
	      _react2.default.createElement(
	        'div',
	        { className: 'col' },
	        _react2.default.createElement(
	          'h2',
	          { className: 'mb-4', style: { fontWeight: 'bold' } },
	          'Our Coalition'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      {
	        className: 'row align-items-center justify-content-center',
	        style: { textAlign: 'center' }
	      },
	      partners.map(function (partner, i) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'col-sm hover01', key: i },
	          _react2.default.createElement(
	            'a',
	            { href: partner.href, target: '_blank' },
	            _react2.default.createElement(
	              'figure',
	              null,
	              _react2.default.createElement(_gatsbyImage2.default, {
	                title: partner.name,
	                alt: partner.name,
	                resolutions: partner.resolutions
	              })
	            )
	          )
	        );
	      })
	    )
	  );
	};
	
	exports.default = PartnerSection;
	module.exports = exports['default'];

/***/ }),

/***/ 54:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// a basic form
	var SimpleForm = function SimpleForm(_ref) {
	  var status = _ref.status,
	      message = _ref.message,
	      className = _ref.className,
	      style = _ref.style,
	      onSubmitted = _ref.onSubmitted;
	
	  var input = void 0;
	  var submit = function submit() {
	    return input && input.value.indexOf('@') > -1 && onSubmitted({
	      EMAIL: input.value
	    });
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { className: className, style: style },
	    status === 'sending' && _react2.default.createElement(
	      'div',
	      { style: { color: 'blue' } },
	      'sending...'
	    ),
	    status === 'error' && _react2.default.createElement('div', {
	      style: { color: 'red' },
	      dangerouslySetInnerHTML: { __html: message }
	    }),
	    status === 'success' && _react2.default.createElement('div', {
	      style: { color: 'green' },
	      dangerouslySetInnerHTML: { __html: message }
	    }),
	    _react2.default.createElement('input', {
	      ref: function ref(node) {
	        return input = node;
	      },
	      type: 'email',
	      placeholder: 'Your email'
	    }),
	    _react2.default.createElement(
	      'button',
	      { onClick: submit },
	      'Submit'
	    )
	  );
	};
	
	exports.default = SimpleForm;
	module.exports = exports['default'];

/***/ }),

/***/ 359:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Country_Neighbors.5851e1ce.mp4";

/***/ }),

/***/ 360:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Country_Neighbors.942bb8d4.webm";

/***/ }),

/***/ 151:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(4);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _gatsbyImage = __webpack_require__(8);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _MailchimpForm = __webpack_require__(143);
	
	var _MailchimpForm2 = _interopRequireDefault(_MailchimpForm);
	
	var _PartnersSection = __webpack_require__(146);
	
	var _PartnersSection2 = _interopRequireDefault(_PartnersSection);
	
	var _EndorsementSection = __webpack_require__(140);
	
	var _EndorsementSection2 = _interopRequireDefault(_EndorsementSection);
	
	var _HomepageVideo = __webpack_require__(142);
	
	var _HomepageVideo2 = _interopRequireDefault(_HomepageVideo);
	
	var _vote_yay_square = __webpack_require__(384);
	
	var _vote_yay_square2 = _interopRequireDefault(_vote_yay_square);
	
	var _placeholder = __webpack_require__(132);
	
	var _placeholder2 = _interopRequireDefault(_placeholder);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IndexPage = function IndexPage(props) {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement('div', {
	      className: 'container-fluid',
	      style: { borderTop: '1rem solid #5faf36' }
	    }),
	    _react2.default.createElement(
	      'div',
	      { className: 'container py-4' },
	      _react2.default.createElement(
	        'div',
	        { className: 'row' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col' },
	          _react2.default.createElement(_gatsbyImage2.default, {
	            title: 'Vote Yay for Prop A. Affordable Housing Bond.',
	            alt: 'Vote Yay for Prop A. Affordable Housing Bond.',
	            sizes: props.data.headerImage.sizes
	          }),
	          _react2.default.createElement(
	            'div',
	            {
	              className: 'my-3 my-md-4 my-lg-5 mx-xl-5'
	              // style={{
	              //   background: `url(${bgImage}) no-repeat center center`,
	              //   backgroundSize: 'cover',
	              //   // background: 'RGBA(0, 0, 0, .1)',
	              // }}
	            },
	            _react2.default.createElement(_HomepageVideo2.default, null)
	          ),
	          _react2.default.createElement(
	            'h1',
	            { style: { fontWeight: 'bold' } },
	            'Austin is in a Housing Crisis.'
	          ),
	          _react2.default.createElement(
	            'h2',
	            { className: 'mb-3', style: { fontWeight: 'bold' } },
	            'On November 6th, vote for an Austin everyone can afford.'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-sm-12 col-md-3' },
	              _react2.default.createElement('img', {
	                src: _vote_yay_square2.default,
	                alt: 'Vote Yay for Prop A Affordable Housing Bond',
	                style: { maxWidth: '100%' }
	              })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col mt-2' },
	              _react2.default.createElement(
	                'p',
	                null,
	                'There\u2019s a lot at stake in this year\u2019s election. If we don\u2019t invest in affordable housing programs now, only the most wealthy people will be able to afford to live here.'
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                'In Austin, we don\u2019t give up on our neighbors \u2014 like Veterans who are at risk of being displaced or living in unsafe conditions; AISD teachers who can\u2019t afford to live in or near the communities they educate; the over 2,000 homeless AISD school students.'
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                'Proposition A, the Affordable Housing Bond, will preserve the Austin we love by keeping people of all incomes in their homes. Vote for an Austin everyone can afford.'
	              ),
	              _react2.default.createElement(
	                'h4',
	                null,
	                '#VoteYayforPropA'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'h2',
	            { className: 'mt-5' },
	            'About Us'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Keep Austin Affordable is a coalition of local nonprofits and community leaders who believe addressing the housing crisis is a high priority for the City and requires investment in programs that help people stay in their homes or find affordable housing options all over the City.'
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_EndorsementSection2.default, {
	      statesmanImage: props.data.statesmanImage,
	      chronicleImage: props.data.chronicleImage
	    }),
	    _react2.default.createElement(_PartnersSection2.default, {
	      aborImage: props.data.aborImage,
	      mealsOnWheelsImage: props.data.mealsOnWheelsImage,
	      affordableCTXImage: props.data.affordableCTXImage,
	      austinHousingCoalitionImage: props.data.austinHousingCoalitionImage,
	      habitatForHumanityImage: props.data.habitatForHumanityImage,
	      foundationCommunitiesImage: props.data.foundationCommunitiesImage,
	      safeImage: props.data.safeImage,
	      housingWorksAustinImage: props.data.housingWorksAustinImage,
	      austinUrbanLeagueImage: props.data.austinUrbanLeagueImage,
	      allianceForRetiredAmericansImage: props.data.allianceForRetiredAmericansImage,
	      easterSealsImage: props.data.easterSealsImage,
	      caritasImage: props.data.caritasImage,
	      dmaImage: props.data.dmaImage,
	      echoImage: props.data.echoImage,
	      lifeworksImage: props.data.lifeworksImage,
	      austinCommunityDesignCenterImage: props.data.austinCommunityDesignCenterImage,
	      gndcImage: props.data.gndcImage
	    }),
	    _react2.default.createElement(_gatsbyImage2.default, {
	      title: 'Photo from June 2018 Rally at City Hall',
	      alt: 'Crowd of Affordable Housing Supporters Rally at City Hall in June 2018',
	      sizes: props.data.homeImage.sizes,
	      style: { width: '100%', maxHeight: '90vh' }
	    })
	  );
	};
	
	exports.default = IndexPage;
	var query = exports.query = '** extracted graphql fragment **';

/***/ }),

/***/ 132:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/placeholder.49c12d69.jpeg";

/***/ }),

/***/ 384:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/vote_yay_square.3926a030.jpg";

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-f95382f18a45894f1b2f.js